export function copyToClipboard(text: string) {
    if (navigator.clipboard && window.isSecureContext) {
        // Modern async clipboard API
        return navigator.clipboard.writeText(text).then(() => {
            console.log("Copied to clipboard:", text);
        }).catch(err => {
            console.error("Failed to copy:", err);
        });
    } else {
        // Fallback for older browsers
        const textArea = document.createElement("textarea");
        textArea.value = text;
        // Avoid scrolling to bottom
        textArea.style.position = "fixed";
        textArea.style.left = "-9999px";
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();

        try {
            document.execCommand("copy");
            console.log("Copied to clipboard (fallback):", text);
        } catch (err) {
            console.error("Fallback copy failed:", err);
        }

        document.body.removeChild(textArea);
    }
}